import { jsx as _jsx } from "react/jsx-runtime";
import { Text, VStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
const BabyWeek17 = () => {
    const { t } = useTranslation();
    return (_jsx(VStack, Object.assign({ space: 2 }, { children: _jsx(Text, { children: t("pregnancy:babyWeek17") }) })));
};
export default BabyWeek17;
